import React, { useEffect, useState, memo } from "react";
import TextInput from "../common/textInput/TextInput";
import DataPicker from "../common/datePicker/DataPicker";
import { FormControl, FormLabel, Grid } from "@mui/material";
import { SelectView } from "../common/selectView/SelectView";
import { useDispatch, useSelector } from "react-redux";
import { addItemInsurveyData } from "../../store/UpdateSurveyData";
import { getDateFromTS } from "../../utils/genericUse/CommonUse";
import Loader from "../../components/common/dialog/Loader";
import {
  ALIGN_ITEMS,
  FLEX_END_ITEMS,
  HELPER_TEXT_STYLE,
  MARGIN_TB_ITEMS,
  Name_Validation,
  SUCCESS_TXT,
  TXT_CENTER,
} from "../../utils/GlobalConstants";
import { NO_SURVEY_SELECTION } from "../../utils/GlobalMessageConstants";
import { SURVEY_CREATION_FORM_VALUES } from "../../utils/GlobalFormConstants";
import Typo from "../common/typo/Typo";
import {
  addItemInSelectedPart,
  addItemInSelectedSurvey,
  addItemInSelectedVehicle,
} from "../../store/SurveyPageData";
import {
  createSurvey,
  deleteSingleSurvey,
  fetchAllSurvey,
  getSingleSurveyDetails,
} from "../../services/SurveyRequest";
import ButtonLayout from "./ButtonLayout";
import { useTranslation } from "react-i18next";

const SurveyCreateForm = (props) => {
  const dispatch = useDispatch();
  const [surveyList, setSurveyList] = useState([]);
  const [selectedSurvey, SetSelectedSurvey] = useState();
  const [error, setError] = useState(false);
  const [nameValidation, setNameValidation] = useState('');
  const [successMsg, setSuccessMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedSurveyInfo, setSelectedSurveyInfo] = useState();
  const { t } = useTranslation();
  //=== maintaining survey info - redux for fleet and store association
  const selectedSurveyFromStore = useSelector(
    (state) => state.surveyData?.surveyData
  );

  useEffect(() => {
    getAllSurvey();
  }, []);

  useEffect(() => {
    setSelectedSurveyInfo(selectedSurveyFromStore);
  }, [selectedSurveyFromStore]);

  const getAllSurvey = async () => {
    setLoading(true);
    try {
      const getSurveyList = await fetchAllSurvey();
      let surveys = [
        { id: "Add New", surveyName: "Add New" },
        ...getSurveyList.surveys,
      ];
      setSurveyList(surveys);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getSurvey = async (id) => {
    setLoading(true);
    try {
      const getSurveyData = await getSingleSurveyDetails(id);
      SetSelectedSurvey(getSurveyData.survey);
      setLoading(false);
      //=== storing selected survey to store to prepopulate association
      dispatch(addItemInsurveyData(getSurveyData.survey));
      //===
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const deleteSurvey = async () => {
    if (!selectedSurvey.id || selectedSurvey.id === "Add New") {
      alert(NO_SURVEY_SELECTION);
    } else {
      if (window.confirm(t("tab1.messages.survey_delete_msg"))) {
        try {
          setLoading(true);
          await deleteSingleSurvey(selectedSurvey.id);
          SetSelectedSurvey({
            surveyName: "",
            lastUpdatedTs: new Date(),
            createdTs: new Date(),
          });
          getAllSurvey();
          dispatch(addItemInsurveyData({}));
          dispatch(addItemInSelectedVehicle({}));
          dispatch(addItemInSelectedPart({}));
          dispatch(addItemInSelectedSurvey({}));
          setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      }
    }
  };

  const saveSurvey = async () => {
    let payload = {
      id: selectedSurvey.id === "Add New" ? null : selectedSurvey.id,
      surveyName: selectedSurvey.surveyName,
      surveyType: 1,
      vehicles: [],
    };

    //if selected survey has association then re sending associated store/fleet while updating survey
    if (selectedSurveyInfo && Object.keys(selectedSurveyInfo).length > 0) {
      payload.storeId = selectedSurveyInfo.storeId
        ? selectedSurveyInfo.storeId
        : "";
      payload.fleetId = selectedSurveyInfo.fleetId
        ? selectedSurveyInfo.fleetId
        : "";
    }

    if (!selectedSurvey.surveyName || selectedSurvey.surveyName.length === 0) {
      setError(true);
      setNameValidation("Please enter a value")
    } else {
      setError(false);
      //===
      try {
        setLoading(true);
        const saveSurveyData = await createSurvey(payload);
         getAllSurvey();
        getSurvey(saveSurveyData.data.id);
        setSuccessMsg(saveSurveyData.data.message);
        setLoading(false);
        
     
        
      } catch (e) {
        console.log("e", e)
        setLoading(false);
      }
    }
  };

  const onHandleChangeUser = (id) => {
    setSuccessMsg("");
    setError(false);
    dispatch(addItemInsurveyData({}));
    if (id !== "Add New") {
      getSurvey(id);
    } else {
      SetSelectedSurvey({
        id: "Add New",
        surveyName: "",
        lastUpdatedTs: new Date(),
        createdTs: new Date(),
      });
    }
  };

  
const onChangeText = (e) => {
  const value = e.target.value;
  const regex = /^[A-Za-z0-9 _-]*$/;

  setSuccessMsg("");
SetSelectedSurvey({ ...selectedSurvey, surveyName: value });
  if (regex.test(value)) {
    setError(false);
    setNameValidation('')
    SetSelectedSurvey({ ...selectedSurvey, surveyName: value });
  } else {
     setNameValidation(Name_Validation)
    setError(true); 
  }
};


  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Grid container sx={ALIGN_ITEMS}>
          <Grid item md={5.8} lg={5.8} xs={12} sm={12}>
            <Grid item md={12} lg={12} xs={12} sm={12}>
              <SelectView
                testid="selectsurvey"
                data={surveyList}
                label={SURVEY_CREATION_FORM_VALUES.surveyLabel}
                onHandleChange={(item) => onHandleChangeUser(item)}
                value={
                  selectedSurvey && selectedSurvey.id ? selectedSurvey.id : ""
                }
              />
            </Grid>
            <Grid container>
              <Grid item md={5.8} lg={5.8} xs={12} sm={5.8}>
                
                <DataPicker
                  label={SURVEY_CREATION_FORM_VALUES.dateCreatedLabel}
                  value={
                    selectedSurvey
                      ? getDateFromTS(selectedSurvey.createdTs)
                      : new Date()
                  }
                  disabled={selectedSurvey ? false : true}
                  readOnly
                />
              </Grid>
              <Grid item md={0.4} lg={0.4} sm={0.4} />

              <Grid item md={5.8} lg={5.8} xs={12} sm={5.8}>
                <DataPicker
                  label={SURVEY_CREATION_FORM_VALUES.dateRevisedLabel}
                  value={
                    selectedSurvey
                      ? getDateFromTS(selectedSurvey.lastUpdatedTs)
                      : new Date()
                  }
                  disabled={selectedSurvey ? false : true}
                  readOnly
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={0.4} lg={0.4} />

          <Grid item md={5.8} lg={5.8} xs={12} sm={12}>
            <Grid item md={12} lg={12} xs={12} sm={12}>
               <FormLabel
                htmlFor={SURVEY_CREATION_FORM_VALUES.nameLabel}
                 sx={{
                  color:  error ? "error.main" : "text.primary",
                  "& .required-asterisk": {
                    color: error ? "error.main" : "inherit",
                  },
                }}
              >
                 {SURVEY_CREATION_FORM_VALUES.nameLabel}
                 {  <span className={"required-asterisk"}> <i>(Required *)</i></span>}
              </FormLabel>
              <TextInput
                label={SURVEY_CREATION_FORM_VALUES.nameLabel}
                onChange={(e) => onChangeText(e)}
                value={
                  selectedSurvey && selectedSurvey.surveyName !== "Add New"
                    ? selectedSurvey.surveyName
                    : ""
                }
                disabled={selectedSurvey ? false : true}
                error={error}
               helperText={nameValidation}
                required={true}
                testid={"surveyName"}
              />
           
            </Grid>

            <Grid container sx={{ ...MARGIN_TB_ITEMS, ...ALIGN_ITEMS }}>
              <Grid item md={12} lg={12} xs={12} sm={12} sx={FLEX_END_ITEMS}>
                <ButtonLayout
                  saveTestID="saveSurvey"
                  saveLabel={"Save Survey"}
                  
                  onClickSave={() => saveSurvey()}
                  saveDisabled={selectedSurvey && nameValidation ==='' ? false : true}
                  deleteLabel={"Delete Survey"}
                  deleteDisabled={
                    selectedSurvey && selectedSurvey.id !== "Add New"
                      ? false
                      : true
                  }
                  deleteOnClick={() => deleteSurvey()}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {selectedSurvey && selectedSurvey.surveyName && successMsg && (
          <Typo
            text={successMsg}
            style={{ ...HELPER_TEXT_STYLE, ...SUCCESS_TXT, ...TXT_CENTER }}
          />
        )}
        
        {loading && (
          <Loader data-testid="loading-sppiner-id" className="Loader-style" />
        )}
      </FormControl>
    </React.Fragment>
  );
};

export default memo(SurveyCreateForm);
